import React from 'react';
import styled, { css } from 'styled-components';
import { Link, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode, EntityCard, EntityCardDefaultProps, EntityCardProps, LinkButton } from '@shapeable/ui';
import { RHODIAN_MID_GREY } from '../../theme';
import { LinkCardThumbnail } from './link-card-thumbnail';
import { ChevronRightThinIconGlyph, DottedChevronRightHeavyIconGlyph } from '@shapeable/icons';
const cls = classNames('link-card');

// -------- Types -------->

// -------- Props -------->

export type LinkCardProps = EntityCardProps & { 
  entity: Link;
};

export const LinkCardDefaultProps: Omit<LinkCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  useEntityColorForBackground: true,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    .shp--entity-card__title {
      display: none;
    }

    .shp--entity-card__head {
      padding: 0;
    }

    .shp--entity-card__content {
      gap: 0;
    }
  `,
});

const ImageStyles = breakpoints({
  base: css`
    
  `,
});

const MetaStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
});

const DescriptionStyles = breakpoints({
  base: css`
    color: ${theme.COLOR('light')};
    font-weight: 300;
    font-size: 0.8em;
    line-height: 1.4;
  `,
});

const LinkButtonStyles = breakpoints({
  base: css`
    width: 100%;
  `,
});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Image: styled(LinkCardThumbnail)`${ImageStyles}`,

    Meta: styled.div`${MetaStyles}`,
      Description: styled(ContentNode)`${DescriptionStyles}`,
      LinkButton: styled(LinkButton)`${LinkButtonStyles}`,
};

export const LinkCard: Shapeable.FC<LinkCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const { description, url, label, color } = entity || {};

  const hasDescription = !!description && description?.text;

  return (
    <My.Container 
      {...cardProps}
      variant='chromeless'
      useLink={false}
      head={
        <My.Image entity={entity} />
      }
      showImage={false}
      showDescription={false}
      colorStripSize={6}
      className={cls.name(className)}
      showExternalLink={false}
      colors={{ background: RHODIAN_MID_GREY }}
      entity={entity}
      showTypeHeader={false}
      
      meta={
        <My.Meta>
          {hasDescription ? <My.Description entity={description} /> : null}
          {
            !!url && 
              <My.LinkButton 
                variant='slim'
                icon={DottedChevronRightHeavyIconGlyph}
                href={url}>
                  {label}
                </My.LinkButton>
          }
        </My.Meta>
      }
    />
  )
};

LinkCard.defaultProps = LinkCardDefaultProps;
LinkCard.cls = cls;